
(function(){
  "use strict";
  const motionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : {matches:false};
  const body = document.body;
  let pausedByUser = false;
  try { pausedByUser = window.sessionStorage.getItem("mz-motion-paused")==="1"; } catch (e) {}
  let observer;
  const observed = new WeakSet();
  const isEnabled = () => !pausedByUser && !motionQuery.matches;
  function revealAll(){
    document.querySelectorAll("[data-mz-reveal]").forEach(el=>{el.classList.remove("mz-motion-pending");el.classList.add("mz-motion-inview");});
    document.querySelectorAll("[data-mz-stagger]").forEach(el=>{el.classList.remove("mz-motion-stagger-pending");el.classList.add("mz-motion-stagger-inview");});
  }
  function sync(){
    const enabled = isEnabled();
    body.classList.add("mz-motion-ready");
    body.classList.toggle("mz-motion-on", enabled);
    body.classList.toggle("mz-motion-off", !enabled);
    document.querySelectorAll("[data-mz-motion-toggle]").forEach(button=>{
      button.disabled = !!motionQuery.matches;
      button.setAttribute("aria-pressed", String(!enabled));
      button.setAttribute("aria-label", enabled ? "Pause animations" : "Resume animations");
      button.innerHTML = motionQuery.matches ? 'Reduced motion on <span aria-hidden="true">✓</span>' : (enabled ? 'Pause motion <span aria-hidden="true">Ⅱ</span>' : 'Resume motion <span aria-hidden="true">▶</span>');
    });
    if (!enabled) revealAll();
  }
  function prepare(root){
    const scope=root||document;
    if(!window.IntersectionObserver || !isEnabled()){revealAll();return;}
    if(!observer)observer = new IntersectionObserver(entries=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting)return;
        const el=entry.target;
        if(el.hasAttribute("data-mz-reveal")){el.classList.remove("mz-motion-pending");el.classList.add("mz-motion-inview");}
        if(el.hasAttribute("data-mz-stagger")){el.classList.remove("mz-motion-stagger-pending");el.classList.add("mz-motion-stagger-inview");}
        observer.unobserve(el);
      });
    },{rootMargin:"0px 0px -8% 0px",threshold:.05});
    scope.querySelectorAll("[data-mz-reveal],[data-mz-stagger]").forEach(el=>{
      if(observed.has(el))return;
      observed.add(el);
      const nearView=el.getBoundingClientRect().top <= window.innerHeight*0.95;
      if(nearView){
        if(el.hasAttribute("data-mz-reveal"))el.classList.add("mz-motion-inview");
        if(el.hasAttribute("data-mz-stagger"))el.classList.add("mz-motion-stagger-inview");
        return;
      }
      if(el.hasAttribute("data-mz-reveal"))el.classList.add("mz-motion-pending");
      if(el.hasAttribute("data-mz-stagger"))el.classList.add("mz-motion-stagger-pending");
      observer.observe(el);
    });
  }
  function init(root){
    sync();
    prepare(root);
  }
  document.addEventListener("click",function(e){
    const toggle=e.target.closest("[data-mz-motion-toggle]");
    if(!toggle)return;
    pausedByUser=!pausedByUser;
    try{window.sessionStorage.setItem("mz-motion-paused",pausedByUser?"1":"0");}catch(err){}
    if(observer){observer.disconnect();observer=null;}
    if(isEnabled()) {
      document.querySelectorAll("[data-mz-reveal]").forEach(el=>{el.classList.remove("mz-motion-pending");el.classList.add("mz-motion-inview");});
      document.querySelectorAll("[data-mz-stagger]").forEach(el=>{el.classList.remove("mz-motion-stagger-pending");el.classList.add("mz-motion-stagger-inview");});
    }
    sync();
  });
  if(motionQuery.addEventListener)motionQuery.addEventListener("change",()=>{if(observer){observer.disconnect();observer=null;}sync();if(isEnabled())prepare(document);});
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>init(document),{once:true});else init(document);
  document.addEventListener("shopify:section:load",e=>init(e.target));
})();
